<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaocurso.GradeCurricular') }}</h1>
        </div>
       
     
  </div>

  <div>
          <form v-if="!editar" @submit.prevent="addNovo()">
              <div class="row">
                  <div class="flex md4 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="dadosgradecurricular.curso"
                      textBy="nome"
                      :options="getallCursos"
                      placeholder="Curso"
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                  
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="dadosgradecurricular.tipo_curso"
                      textBy="nome"
                      :options="getallTipoCurso"
                      placeholder="Tipo Curso"
                    />
                    
                
                  </div>

                      <div class="flex md3 sm12 xs12">
                      <va-input
                      :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.carga_horaria"
                        placeholder="Carga horaria "
                      />
                    </div>


                 
                
                </div>
                <div class="row">
                  <div class="flex md4 sm12 xs12">
                     <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.info_pagamento"
                        placeholder="Pagos "
                        
                      />
                  </div>

                  <div class="flex md4 sm12 xs12">
                  
                    <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.info_periodo"
                        placeholder=" Periodo"
                      
                      />
                    
                
                  </div>
                  
                      <div class="flex md4 sm12 xs12">
                      <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.url_video"
                        placeholder="Link video "
                      
                      />
                    </div>

                </div>
                  <div class="row">
                  <div class="flex md4 sm12 xs12">
                     <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.info_justificativa"
                        placeholder="Justificativa "
                        type="textarea"
                  
                      />
                  </div>

                  <div class="flex md4 sm12 xs12">
                  
                    <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.info_objetivo"
                        placeholder=" Objetivo"
                        type="textarea"
                        
                      />
                    
                
                  </div>
                  
                      <div class="flex md4 sm12 xs12">
                      <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="dadosgradecurricular.info_publico"
                        placeholder="Publico "
                        type="textarea"
                        
                      
                      />
                    </div>

                </div>
                <div class="row text-center">
                   <div class="flex md2 sm12 xs12 text-center">
                    <va-button type="submit" class="text-center"   color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                 </div>
                </div>

          </form>

           <form v-if="editar" @submit.prevent="salvarEditar()">
             
                <div class="row">
                   <div class="flex md3 sm12 xs12">
                     <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="editdadosgradecurricular.carga_horaria"
                        placeholder="Carga_horaria "
                        
                      />
                  </div>
                  <div class="flex md3 sm12 xs12">
                     <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="editdadosgradecurricular.info_pagamento"
                        placeholder="Pagos "
                        
                      />
                  </div>

                  <div class="flex md3 sm12 xs12">
                  
                    <va-input
                        :label="$t('forms.selects.simple')"
                        v-model="editdadosgradecurricular.info_periodo"
                        placeholder=" Periodo"
                      
                      />
                    
                
                  </div>
                  
                      <div class="flex md3 sm12 xs12">
                      <va-input
                        label="Video"
                        v-model="editdadosgradecurricular.url_video"
                        placeholder="Link video "
                      
                      />
                    </div>

                </div>
                  <div class="row">
                  <div class="flex md4 sm12 xs12">
                     <va-input
                        label="Justificativa español"
                        v-model="editdadosgradecurricular.info_justificativa"
                        placeholder="Justificativa "
                        type="textarea"
                  
                      />
                  </div>

                  <div class="flex md4 sm12 xs12">
                  
                    <va-input
                        label="Objetivo español"
                        v-model="editdadosgradecurricular.info_objetivo"
                        placeholder=" Objetivo"
                        type="textarea"
                        
                      />
                    
                
                  </div>
                  
                      <div class="flex md4 sm12 xs12">
                      <va-input
                        label="Publico español"
                        v-model="editdadosgradecurricular.info_publico"
                        placeholder="Publico "
                        type="textarea"
                        
                      
                      />
                    </div>

                </div>

                <!-- Portugues -->
                 <div class="row">
                  <div class="flex md4 sm12 xs12">
                     <va-input
                        label="Justificativa portugues"
                        v-model="editdadosgradecurricular.info_justificativa_pt"
                        placeholder="Justificativa "
                        type="textarea"
                  
                      />
                  </div>

                  <div class="flex md4 sm12 xs12">
                  
                    <va-input
                        label="Objetivo portugues"
                        v-model="editdadosgradecurricular.info_objetivo_pt"
                        placeholder=" Objetivo"
                        type="textarea"
                        
                      />
                    
                
                  </div>
                  
                      <div class="flex md4 sm12 xs12">
                      <va-input
                        label="Publico portugues"
                        v-model="editdadosgradecurricular.info_publico_pt"
                        placeholder="Publico "
                        type="textarea"
                        
                      
                      />
                    </div>

                </div>
                <div class="row text-center">
                   <div class="flex md2 sm12 xs12 text-center">
                    <va-button type="submit" class="text-center"  color="dark"> {{ $t('arealuno.Salvar') }}</va-button>
                 </div>
                </div>

          </form>

  </div>
 
    <va-data-table
          :fields="fields"
          :data="getGradeCurricular"
          hoverable
          no-pagination
          >
          
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
                <va-button flat small color="info" @click="abrirEditar(props.rowData)" class="ma-0">
                  Editar
                </va-button>
                <va-button flat small color="primary" @click="abrirGradeCurricular(props.rowData)" class="ma-0">
                  {{ $t('tables.entrar') }}
                </va-button>

                <va-button flat small color="danger" @click="remove(props.rowData)" class="ma-0">
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
              
        </va-data-table>

   

</div>

      
 
</template>

<script>


export default {
  name: 'gradecurricular',
  

  data () {
      return {
        editar:false,
       
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
      
        dadosgradecurricular:{
          
            curso:'',
            tipo_curso:'',
            carga_horaria:'',
            info_pagamento:'',
            info_periodo:'',
            url_video:'',
            info_justificativa:'',
            info_objetivo:'',
            info_publico:'',
          },

          editdadosgradecurricular:{
      
            carga_horaria:'',
            info_pagamento:'',
            info_periodo:'',
            url_video:'',
            info_justificativa:'',
            info_objetivo:'',
            info_publico:'',
            info_justificativa_pt:'',
            info_objetivo_pt:'',
            info_publico_pt:'',
          },
     
     
      }
    },
    created (){

    this.buscar()
    },
    
  computed: {

    getGradeCurricular (){
        return  this.$store.state.gradecurricular.gradecurricular   
        
    },
    getallTipoCurso(){
      return this.$store.state.tipo_cursos.tipoCurso
    },
    getallCursos(){
      return this.$store.state.cursos.cursos
    },
  
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_curso',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'nome_tipo_curso',
          title: this.$t('tables.headings.email'),
        },
         {
          name: 'carga_horaria',
          title: this.$t('tables.headings.email'),
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  },

  methods: {

      abrirEditar(value){
       
       this.editdadosgradecurricular = {
            id:value.id,
            carga_horaria:value.carga_horaria,
            info_pagamento:value.info_pagamento,
            info_periodo:value.info_periodo,
            url_video:value.url_video,
            info_justificativa:value.info_justificativa,
            info_objetivo:value.info_objetivo,
            info_publico:value.info_publico,
            info_justificativa_pt:value.info_justificativa_pt,
            info_objetivo_pt:value.info_objetivo_pt,
            info_publico_pt:value.info_publico_pt,
       }
     
        this.editar = true

      },

      abrirGradeCurricular (value) {
      
      this.$store.dispatch('setGradeCurricular',value);
      this.$emit('trocar_component', 'setgradecurricular');
      
        },

     buscar () {

      this.$store.dispatch('allGradeCurricular',this.dadosgradecurricular)
      this.$store.dispatch('allTipoCurso',)
      this.$store.dispatch('allCurso')

        },

   async addNovo () {
      
    await  this.$store.dispatch('addGradeCurricular',this.dadosgradecurricular)
        this.buscar()
        this.dadosgradecurricular ={
            curso:'',
            tipo_curso:'',
            carga_horaria:'',
            info_pagamento:'',
            info_periodo:'',
            url_video:'',
            info_justificativa:'',
            info_objetivo:'',
            info_publico:'',
            
          }
    },

  async salvarEditar () {
     
    await  this.$store.dispatch('editarGradeCurricular',this.editdadosgradecurricular)
    .then(response => {
              //  this.buscar()
        this.editdadosgradecurricular ={
        
            carga_horaria:'',
            info_pagamento:'',
            info_periodo:'',
            url_video:'',
            info_justificativa:'',
            info_objetivo:'',
            info_publico:'',
            info_justificativa_pt:'',
            info_objetivo_pt:'',
            info_publico_pt:'',
            
          }

           this.editar = false
           this.buscar()
             

        })
        .catch((error) => {
            console.log(error);
        })
    
     
    }

  },
}
</script>

<style lang="scss">

</style>
